import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import NProgress from '@/utils/nprogress'

Vue.use(Router)

const router =  new Router({
  mode:'history',
  routes: [
    {
      path:'/login',
      mane:'login',
      component:()=>import("../pages/login/index")
    },
    {
      path: '/',
      name: 'layout',
      redirect:'/workBench',
      component: ()=>import("../pages/layout/index"),
      children:[
        {
          path:'/workBench',
          name:'workBench',
          meta:{
            title:'客户视图',
            lv:1,
            roles: ['factoryAdmin','user','inspector']
          },
          icon:'el-icon-menu',
          component:()=>import("../pages/workBench/index")
        },
        {
          path:'/achievement',
          name:'achievement',
          meta:{
            title:'业绩视图',
            lv:1,
            roles: ['factoryAdmin','inspector']
          },
          icon:'el-icon-menu',
          component:()=>import("../pages/achievement/index")
        },
        {
          path:'/customer',
          name:'customer',
          meta:{
            title:'客户管理',
            lv:1,
            roles: ['factoryAdmin','user','inspector']
          },
          icon:'el-icon-s-custom',
          component:()=>import("../pages/customer/index")
        },
        {
          path:'/customer-audit',
          name:'customer-audit',
          meta:{
            title:'客户授权管理',
            lv:1,
            roles:['inspector','user']
          },
          icon:'el-icon-s-check',
          component:()=>import("../pages/customerAudit/index")
        },
        {
          path:'/customer-overdue',
          name:'customer-overdue',
          meta:{
            title:'逾期客户管理',
            lv:1,
            roles:['inspector','user']
          },
          icon:'el-icon-s-check',
          component:()=>import("../pages/customerOverdue/index")
        },
        {
          path:'/customer/cusIndex',
          name:'cusIndex',
          meta:{
            title:'客户主页',
            lv:2
          },
          component:()=>import("../pages/customer/cusIndex")
        },
        {
          path:'/overdue-customer',
          name:'overdue-customer',
          meta:{
            title:'逾期客户记录',
            lv:1,
            roles: ['factoryAdmin','user','inspector']
          },
          icon:'el-icon-s-custom',
          component:()=>import("../pages/overdueCustomer/index")
        },
        {
          path:'/warning-customer',
          name:'warning-customer',
          meta:{
            title:'客户风险预警',
            lv:1,
            roles: ['factoryAdmin','user','inspector']
          },
          icon:'el-icon-warning',
          component:()=>import("../pages/warningCustomer/index")
        },
        {
          path:'/customerScoreExamine',
          name:'customerScoreExamine',
          meta:{
            title:'客户评分审核',
            lv:1,
            roles: ['inspector','schedule']
          },
          icon:'el-icon-medal',
          component:()=>import("../pages/customerScoreExamine/index")
        },
        {
          path:'/user',
          name:'user',
          meta:{
            title:'账号管理',
            lv:1,
            roles: ['factoryAdmin']
          },
          icon:'el-icon-user',
          component:()=>import("../pages/user/index")
        },
        {
          path:'/group',
          name:'group',
          meta:{
            title:'业务分组',
            lv:1,
            roles: ['factoryAdmin']
          },
          icon:'el-icon-connection',
          component:()=>import("../pages/group/index")
        },
        {
          path:'/score',
          name:'score',
          meta:{
            title:'打分记录',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-magic-stick',
          component:()=>import("../pages/score/index")
        },
        {
          path:'/log',
          name:'log',
          meta:{
            title:'行为记录',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-document',
          component:()=>import("../pages/log/index")
        },
        {
          path:'/myreport',
          name:'myreport',
          meta:{
            title:'我的周报',
            lv:1,
            roles: ['user']
          },
          icon:'el-icon-date',
          component:()=>import("../pages/myreport/index")
        },
        {
          path:'/myreport/addreport',
          name:'addreport',
          meta:{
            title:'填写周报',
            lv:2,
            roles: ['user']
          },
          component:()=>import("../pages/myreport/add")
        },
        {
          path:'/report',
          name:'report',
          meta:{
            title:'历史周报',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-data-line',
          component:()=>import("../pages/report/index")
        },
        {
          path:'/reportdetail',
          name:'reportdetail',
          meta:{
            title:'周报详情',
            lv:2,
            roles: ['inspector','user']
          },
          icon:'el-icon-data-line',
          component:()=>import("../pages/myreport/add")
        },
        {
          path:'/chance',
          name:'chance',
          meta:{
            title:'项目机会',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-collection-tag',
          component:()=>import("../pages/chance/index")
        },
        // {
        //   path:'/flowLog',
        //   name:'flowLog',
        //   meta:{
        //     title:'跟进记录',
        //     lv:1,
        //     roles: ['inspector']
        //   },
        //   icon:'el-icon-tickets',
        //   component:()=>import("../pages/flowLog/index")
        // },
        {
          path:'/missing',
          name:'missing',
          meta:{
            title:'任务管理',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-first-aid-kit',
          component:()=>import("../pages/missing/index")
        },
        {
          path:'/audit',
          name:'audit',
          meta:{
            title:'客户审核',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-s-check',
          component:()=>import("../pages/audit/index")
        },
        {
          path:'/maintainTotal',
          name:'maintainTotal',
          meta:{
            title:'维护统计',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-s-data',
          component:()=>import("../pages/maintainTotal/index")
        },
        {
          path:'/performance',
          name:'performance',
          meta:{
            title:'业绩统计',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-tickets',
          component:()=>import("../pages/performance/index")
        },
        {
          path:'/appraisal',
          name:'appraisal',
          meta:{
            title:'绩效考核',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-notebook-2',
          component:()=>import("../pages/appraisal/index")
        },
        {
          path:'/performance-assistant',
          name:'performance-assistant',
          meta:{
            title:'业务助理绩效',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-notebook-2',
          component:()=>import("../pages/performanceAssistant/index")
        },
        {
          path:'/demand',
          name:'demand',
          meta:{
            title:'调油需求',
            lv:1,
            roles: ['inspector','user']
          },
          icon:'el-icon-notebook-1',
          component:()=>import("../pages/demand/index")
        },
        {
          path:'/quotation',
          name:'quotation',
          meta:{
            title:'报价',
            lv:1,
            roles: ['inspector','user',]
          },
          icon:'el-icon-notebook-1',
          component:()=>import("../pages/quotation/index")
        },
        {
          path:'/quotation/add',
          name:'addQuotation',
          meta:{
            title:'新增报价',
            lv:2
          },
          component:()=>import("../pages/quotation/detail")
        },
        {
          path:'/quotation/detail',
          name:'quotationDetail',
          meta:{
            title:'报价详情',
            lv:2
          },
          component:()=>import("../pages/quotation/detail")
        },
        {
          path:'/factory',
          name:'factory',
          meta:{
            title:'工厂配置',
            lv:1,
            roles: ['factoryAdmin']
          },
          icon:'el-icon-notebook-1',
          component:()=>import("../pages/factory/index")
        },
        {
          path:'/compass',
          name:'compass',
          meta:{
            title:'数据罗盘',
            lv:1,
            roles: ['inspector']
          },
          icon:'el-icon-menu',
          component:()=>import("../pages/compass/index")
        },
        {
          path:'/my-apply',
          name:'my-apply',
          meta:{
            title:'我的研发申请',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-menu',
          component:()=>import("../pages/dev/index")
        },
        {
          path:'/my-examine',
          name:'my-examine',
          meta:{
            title:'我的研发审批',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-menu',
          component:()=>import("../pages/dev/examine")
        },
        {
          path:'/apply-add',
          name:'apply-add',
          meta:{
            title:'打样申请',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/dev/add")
        },
        {
          path:'/apply-detail',
          name:'apply-detail',
          meta:{
            title:'申请详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/dev/detail")
        },
        {
          path:'/apply-examine',
          name:'apply-examine',
          meta:{
            title:'打样申请审批',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/dev/detail")
        },
        {
          path:'/process-config',
          name:'process-config',
          meta:{
            title:'流程配置',
            lv:1,
            roles: ['factoryAdmin'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/processConfig/index")
        },
        {
          path:'/process-config-add',
          name:'process-config-add',
          meta:{
            title:'新建流程',
            lv:2,
            roles: ['factoryAdmin'],
          },
          component:()=>import("../pages/processConfig/detail")
        },
        {
          path:'/process-config-edit',
          name:'process-config-edit',
          meta:{
            title:'流程详情',
            lv:2,
            roles: ['factoryAdmin'],
          },
          component:()=>import("../pages/processConfig/detail")
        },
        {
          path:'/supplier-import',
          name:'supplier-import',
          meta:{
            title:'供应商导入',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/supplier/index")
        },
        {
          path:'/supplier-add',
          name:'supplier-add',
          meta:{
            title:'供应商导入申请',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/supplier/add")
        },
        {
          path:'/supplier-detail',
          name:'supplier-detail',
          meta:{
            title:'供应商导入申请详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/supplier/detail")
        },
        {
          path:'/supplier-examine',
          name:'supplier-examine',
          meta:{
            title:'供应商导入申请审核',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/supplier/detail")
        },
        {
          path:'/quote',
          name:'quote',
          meta:{
            title:'报价审批',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/quote/index")
        },
        {
          path:'/quote-add',
          name:'quote-add',
          meta:{
            title:'报价申请',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/quote/add")
        },
        {
          path:'/quote-detail',
          name:'quote-detail',
          meta:{
            title:'报价申请详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/quote/detail")
        },
        {
          path:'/quote-examine',
          name:'quote-examine',
          meta:{
            title:'报价申请审核',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/quote/detail")
        },
        {
          path:'/price-history',
          name:'price-history',
          meta:{
            title:'报价走势查询',
            lv:1,
            roles: ['purchase'],
          },
          icon:'el-icon-data-line',
          component:()=>import("../pages/priceHistory/index")
        },
        {
          path:'/temp-material',
          name:'tempMaterial',
          meta:{
            title:'物料引入',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/tempMaterial/index")
        },
        {
          path:'/temp-material-add',
          name:'tempMaterialAdd',
          meta:{
            title:'新增',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/tempMaterial/add")
        },
        {
          path:'/temp-material-detail',
          name:'tempMaterialDetail',
          meta:{
            title:'详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/tempMaterial/detail")
        },
        {
          path:'/temp-material-batch-add',
          name:'tempMaterialBatchAdd',
          meta:{
            title:'批量新增',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/tempMaterial/batchAdd")
        },
        {
          path:'/temp-material-edit',
          name:'tempMaterialEdit',
          meta:{
            title:'编辑',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/tempMaterial/add")
        },
        {
          path:'/temp-material-examine',
          name:'tempMaterialExamine',
          meta:{
            title:'审批',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/tempMaterial/detail")
        },
        {
          path:'/sample',
          name:'sample',
          meta:{
            title:'索样管理',
            lv:1,
            roles: ['factoryAdmin','rd','purchase'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/sample/index")
        },
        {
          path:'/sample-detail',
          name:'sample-detail',
          meta:{
            title:'索样详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/sample/detail")
        },
        {
          path:'/output',
          name:'output',
          meta:{
            title:'量产申请',
            lv:1,
            roles: ['factoryAdmin','user','inspector','rd_engineer','rd_supervisor','schedule','purchase'],
          },
          icon:'el-icon-share',
          component:()=>import("../pages/output/index")
        },
        {
          path:'/output-add',
          name:'output-add',
          meta:{
            title:'量产申请',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/output/add")
        },
        {
          path:'/output-detail',
          name:'output-detail',
          meta:{
            title:'量产申请详情',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/output/detail")
        },
        {
          path:'/output-examine',
          name:'output-examine',
          meta:{
            title:'量产申请审批',
            lv:2,
            roles: [],
          },
          component:()=>import("../pages/output/detail")
        },
        {
          path:'/outside-goods',
          name:'outside-goods',
          meta:{
            title:'外部商品',
            lv:1,
            roles: ['purchase'],
          },
          icon:'el-icon-s-goods',
          component:()=>import("../pages/outsideGoods/index")
        },
        {
          path:'/stock',
          name:'stock',
          meta:{
            title:'物料库存',
            lv:1,
            roles: ['purchase'],
          },
          icon:'el-icon-s-goods',
          component:()=>import("../pages/stock/index")
        },
        {
          path:'/price',
          name:'price',
          meta:{
            title:'采购价格稽查',
            lv:1,
            roles: ['factoryAdmin','purchase'],
          },
          icon:'el-icon-s-shop',
          component:()=>import("../pages/price/index")
        },
        {
          path:'/print',
          name:'print',
          meta:{
            title:'订单打标签',
            lv:1,
            roles: [],
          },
          icon:'el-icon-printer',
          component:()=>import("../pages/print/index")
        },
        {
          path:'/purdeliverytime',
          name:'purdeliverytime',
          meta:{
            title:'采购交期',
            lv:1,
            roles: ['factoryAdmin','schedule','purchase'],
          },
          icon:'el-icon-date',
          component:()=>import("../pages/purdeliverytime/index")
        },
        {
          path:'/produce',
          name:'produce',
          meta:{
            title:'生产计划',
            lv:1,
            roles: ['factoryAdmin','schedule','purchase', 'production'],
          },
          icon:'el-icon-date',
          component:()=>import("../pages/produce/index")
        },
        {
          path:'/produce/newplan',
          name:'newplan',
          meta:{
            title:'新计划',
            lv:2
          },
          component:()=>import("../pages/produce/newplan")
        },
        {
          path:'/customerDemand',
          name:'customerDemand',
          meta:{
            title:'客户需求',
            lv:1,
            roles: ['factoryAdmin','schedule'],
          },
          icon:'el-icon-date',
          component:()=>import("../pages/customerDemand/index")
        },
      ]
    },
    {
      path:'/auth-redirect',
      mane:'auth-redirect',
      component:()=>import("../pages/login/auth-redirect")
    }
  ]
})

router.beforeEach((to,from,next)=>{
  NProgress.start()
  if(to.meta.lv==1){
    store.commit('changePage',to.path)
  }
  next()
})

router.afterEach(()=>{
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js